import { api, type Api } from "@api/bot-base-api-request";
import { useQuery } from "@tanstack/react-query";

const BOT_GET_DEFAULT_SLIPPAGE_QUERY_KEY = "bot-get-default-slippage";

// Response type from the API
interface BotDefaultSlippageResponse {
  solanaSlippage: number;
  ethereumSlippage: number;
}

const fetchBotDefaultSlippage = async (
  api: Api,
): Promise<BotDefaultSlippageResponse> => api.get("defaultSlippage").json();

const useGetBotDefaultSlippage = () =>
  useQuery<BotDefaultSlippageResponse>({
    queryKey: [BOT_GET_DEFAULT_SLIPPAGE_QUERY_KEY],
    queryFn: async () => fetchBotDefaultSlippage(api),
  });

export {
  useGetBotDefaultSlippage as useGetBotDefaultSlippage,
  fetchBotDefaultSlippage as fetchBotDefaultSlippage,
  BOT_GET_DEFAULT_SLIPPAGE_QUERY_KEY as BOT_GET_DEFAULT_SLIPPAGE_QUERY_KEY,
  type BotDefaultSlippageResponse as BotDefaultSlippageResponse,
};
